const TEAM_TYPE_FIELDS = ['name', 'description'];

export const EMPTY_TEAM_TYPE_FORM = Object.freeze({
    name: '',
    description: '',
});

export const teamTypeToForm = (teamType) => ({
    name: teamType?.name ?? '',
    description: teamType?.description ?? '',
});

export const validateTeamTypeForm = (form) => {
    const errors = {};
    if (!form.name.trim()) {
        errors.name = 'Name is required';
    } else if (form.name.trim().length > 100) {
        errors.name = 'Name must be at most 100 characters';
    }
    return errors;
};

export const buildTeamTypePayload = (form) => ({
    name: form.name.trim(),
    description: form.description.trim(),
});

export const extractTeamTypeFieldErrors = (errData) => {
    const errors = {};
    TEAM_TYPE_FIELDS.forEach((field) => {
        const value = errData?.[field];
        if (value) {
            errors[field] = Array.isArray(value) ? value[0] : value;
        }
    });
    return errors;
};

export const extractTeamTypeFormError = (errData, status) => {
    if (status === 403) {
        return 'You do not have permission to manage team types.';
    }
    const nonField = errData?.non_field_errors;
    if (Array.isArray(nonField) && nonField.length) return nonField[0];
    return errData?.detail || '';
};
